import  { instance  } from "../api";
const fetchPageById = (setPageAttributes , id) => {
  
      instance.get(`/api/pages/${id}`)
      .then((result)=>  { 
        setPageAttributes(result.data)
       
      
     })                  
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchPageById;
export const fetchFaq = (setPages) => {
  
  instance.get(`/api/pages/isFaq`)
  .then((result)=>  { 
    console.log('data page' , result.data)
    setPages(result.data)
 
   
  
 })                  
.catch ((error) =>{console.log('error', error)
  
})
};